module.exports = __webpack_public_path__ + "static/media/SubscriptionLock.63fc1441.svg";